import AppStandardButton from "../../components/UI/AppButtons";
import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { useSearchParams } from "react-router-dom";
import TagManager from "react-gtm-module";
import BookingGetters from "../../store/onlineBooking/getters";

export function WireTransferConfirm() {
  const appSettings = BookingGetters.getAppSettings();
  const paymentDetails = BookingGetters.getSelectedVehicleDetails();
  const price = paymentDetails.paymentDetails.price;
  const [searchParams] = useSearchParams();
  const dbId = searchParams.get("dbId");

  const [showGtagManagerEvent, setGtagManagerEvent] = useState(
    appSettings?.gtagManagerEvent || ""
  );
  const [showGTagManagerSendTo, setGTagManagerSendTo] = useState(
    appSettings?.gTagManagerSendTo || ""
  );
  const [showGTagManagerCurrency, setGTagManagerCurrency] = useState(
    appSettings?.gTagManagerCurrency || ""
  );
  const [isTagManagerDataLayerEnabled, setIsTagManagerDataLayerEnabled] =
    useState(false);
  const [showGtagManagerValue, setGtagManagerValue] = useState(false);
  const [showGTagManagerTransactionId, setGTagManagerTransactionId] =
    useState(false);
  const [tagManagerId, setTagManagerId] = useState("");
  const [isTagManagerEnabled, setIsTagManagerEnabled] = useState(false);
  const showPrice = showGtagManagerValue ? price : null;
  const showDbId = showGTagManagerTransactionId ? dbId : null;

  const setBooleanValue = (setter, value) => setter(!!value);

  const settingsMap = [
    {
      setter: setIsTagManagerDataLayerEnabled,
      valueKey: "enableDataLayer",
      isBoolean: true,
    },
    {
      setter: setGTagManagerCurrency,
      valueKey: "gTagManagerCurrency",
      defaultValue: "",
    },
    {
      setter: setGTagManagerSendTo,
      valueKey: "gTagManagerSendTo",
      defaultValue: "",
    },
    {
      setter: setGtagManagerEvent,
      valueKey: "gtagManagerEvent",
      defaultValue: "",
    },
    {
      setter: setGtagManagerValue,
      valueKey: "enableGtagManagerValue",
      isBoolean: true,
    },
    {
      setter: setGTagManagerTransactionId,
      valueKey: "enableGTagManagerTranscationId",
      isBoolean: true,
    },
    {
      setter: setIsTagManagerEnabled,
      valueKey: "enableTagManager",
      isBoolean: true,
    },
    { setter: setTagManagerId, valueKey: "tagManagerId", defaultValue: "" },
  ];

  const applyAppSettings = (settings = {}) => {
    settingsMap.forEach(({ setter, valueKey, isBoolean, defaultValue }) => {
      const value = settings?.[valueKey];
      if (isBoolean) {
        setBooleanValue(setter, value);
      } else {
        setter(value ?? defaultValue ?? "");
      }
    });
  };

  // const applyAppSettings = (settings) => {
  //   setIsTagManagerDataLayerEnabled(!!settings?.enableDataLayer);
  //   setGTagManagerCurrency(settings?.gTagManagerCurrency || "");
  //   setGTagManagerSendTo(settings?.gTagManagerSendTo || "");
  //   setGtagManagerEvent(settings?.gtagManagerEvent || "");
  //   setGtagManagerValue(!!settings?.enableGtagManagerValue);
  //   setGTagManagerTransactionId(!!settings?.enableGTagManagerTranscationId);
  //   setIsTagManagerEnabled(!!settings?.enableTagManager);
  //   setTagManagerId(settings?.tagManagerId || "");
  // };
  useEffect(() => {
    applyAppSettings(appSettings);
  }, [appSettings]);

  useEffect(() => {
    if (isTagManagerDataLayerEnabled) {
      const tagManagerArgs = {
        dataLayer: {
          event: showGtagManagerEvent,
          send_to: showGTagManagerSendTo,
          value: showPrice,
          currency: showGTagManagerCurrency,
          transaction_id: showDbId,
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  }, [isTagManagerDataLayerEnabled]);
  useEffect(() => {
    if (isTagManagerEnabled && tagManagerId != "") {
      const tagManagerArgs = {
        gtmId: tagManagerId,
      };
      TagManager.initialize(tagManagerArgs); // google tag manager integrated along with the preferences
    }
  }, [tagManagerId, isTagManagerEnabled]);
  const isSmallScreen = window.innerWidth <= 768;
  return (
    <section
      className={`min-h-[100vh] box-border ${
        !isSmallScreen ? "px-44 " : ""
      } flex flex-col border-t-2 border-solid border-grey-300`}
      style={{
        backgroundColor: "black",
      }}
    >
      <header className="grow flex flex-col items-center justif-center gap-4 box-border py-8">
        <img src="/assets/images/success-icon@2x.png" className="h-36 w-36" />
        <h1 className="text-3xl font-bold text-[#FFFFFF] py-2">
          {t("Congratulations! Your Booking Is Completed")}
        </h1>
        <p className="font-bold text-black-600">
          {/* Reservation Code:{" "} */}
          {/* Web Check In Code:{" "}
            <span className="font-bold text-[#5cbc14]">DG-87450</span> */}
        </p>
        <div className="flex flex-col-2 ">
          {" "}
          <AppStandardButton
            href="/"
            className={"w-fit py-4 mx-8"}
            variant="outlined"
            color="secondaryColor"
            style={{ borderRadius: "5", borderColor: "#FFFFFF" }}
          >
            {/* Go to Account */}
            <span className="normal-case text-[#FFFFFF] p-1 text-lg">
              {" "}
              Homepage
            </span>
          </AppStandardButton>
          <AppStandardButton
            href="/"
            className={"w-fit py-4 mx-8"}
            color="secondaryColor"
            variant="outlined"
            style={{ borderRadius: "5", borderColor: "#FFFFFF" }}
          >
            {/* Go to Account */}
            <span className="normal-case text-[#FFFFFF] p-1 text-lg">
              {" "}
              Dashboard
            </span>
          </AppStandardButton>
        </div>
      </header>
    </section>
  );
}
